import React, { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext()

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('life-user'))
    setUser(storedUser)
  }, [])

  const getUser = () => {
    return JSON.parse(localStorage.getItem('life-user'))
  }

  const userIsFullAuthenticated = () => {
    let storedUser = localStorage.getItem('life-user')
    if (!storedUser || storedUser == null || storedUser === "null" || storedUser==='{}') {
      return false
    }
    storedUser = JSON.parse(storedUser)
    // if user has token expired, logout user
    if (Date.now() > storedUser.data.exp * 1000) {
      userLogout();
      return false
    }
    if (storedUser.data && (storedUser.data.patients.length > 1 || storedUser.data.patients.length===0)) {
      return false;
    }
    return true
  }

  const userIsAuthenticated = () => {
    let storedUser = localStorage.getItem('life-user')
    if (!storedUser || storedUser == null || storedUser === "null" || storedUser==='{}') {
      return false
    }
    storedUser = JSON.parse(storedUser)
    // if user has token expired, logout user
    if (Date.now() > storedUser.data.exp * 1000) {
      userLogout();
      return false
    }
    return true
  }

  const userLogin = user => {
    localStorage.setItem('life-user', JSON.stringify(user))
    setUser(user)
  }

  const userLogout = () => {
    localStorage.removeItem('life-user')
    setUser(null)
    window.location.href = "/";
  }

  const contextValue = {
    user,
    getUser,
    userIsAuthenticated,
    userIsFullAuthenticated,
    userLogin,
    userLogout,
  }

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext

export function useAuth() {
  return useContext(AuthContext)
}

export { AuthProvider }